import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { AddTimesIcon, ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon, TextFormatIcon } from '@calendly/ui/components/icons';
import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useFetchEventTypeQuery } from 'features/event_type_provider';
import { useTrack } from 'hooks/analytics_events';
import { camelize } from 'services/string_utils';
import { OfferAvailabilityDropdown } from '../offer_availability';
import { trackSendViaCalendly } from './analytics';
import { determineTimezone, hasRequiredFields, processAvailabilityData } from './utils';
const richTextBodyFieldButtonContainerCss = "rx587ey";
const RichTextBodyFieldButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(richTextBodyFieldButtonContainerCss, props.className)} />;
});
const textEditorIconWrapperToggleToolbarCss = "t1l3o0ub";
const textEditorIconWrapperCss = "t1kulu62";
const TextEditorIconWrapper = forwardRef((props, ref) => {
  const {
    toggleToolbar,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(textEditorIconWrapperCss, {
    [textEditorIconWrapperToggleToolbarCss]: toggleToolbar
  }, props.className)} />;
});
const suggestTimesButtonIsExpandedCss = "sc7neb2";
const suggestTimesButtonCss = "s1dybgcy";
const SuggestTimesButton = forwardRef((props, ref) => {
  const {
    isExpanded,
    ...restProps
  } = props;
  return <Button ref={ref} {...restProps} className={classNames(suggestTimesButtonCss, {
    [suggestTimesButtonIsExpandedCss]: isExpanded
  }, props.className)} />;
});
const SuggestTimesButtonComponent = ({
  onClick,
  isExpanded,
  disabled,
  loading
}) => <SuggestTimesButton size="small" decoration="secondary-outline" onClick={onClick} isExpanded={isExpanded} disabled={disabled}>
    {loading ? <Loader size="small" /> : <>
        <AddTimesIcon />
        {I18n.t('publisher.send_from_calendly.action.suggest_times')}
        {isExpanded ? <ArrowChevronUpMiniIcon data-component="arrow-up" /> : <ArrowChevronDownMiniIcon data-component="arrow-down" />}
      </>}
  </SuggestTimesButton>;
export const SuggestTimes = ({
  eventType: initialEventType,
  timeNotation,
  timezone,
  availabilityOption,
  onAvailabilitySelect,
  handleEditorToolbarToggle,
  ariaLabelledBy,
  toggleToolbar,
  contact,
  source,
  isSendFromCalendly = false
}) => {
  const REQUIRED_FIELDS = ['id', 'nextAvailability', 'lockTimezoneEnabled', 'lockTimezoneContent', 'availabilityTimezone'];
  const {
    data: eventType,
    isFetching
  } = useFetchEventTypeQuery(initialEventType, {
    skip: hasRequiredFields(initialEventType, REQUIRED_FIELDS)
  });
  const currentEventType = camelize(eventType || initialEventType || {});
  const {
    id: eventTypeId,
    locale,
    nextAvailability,
    lockTimezoneEnabled,
    lockTimezoneContent,
    availabilityTimezone,
    bookingUrl
  } = currentEventType;
  const resolvedTimezone = determineTimezone(contact?.timeZone || timezone, lockTimezoneEnabled, lockTimezoneContent, availabilityTimezone);
  const hasRequiredData = hasRequiredFields(eventType, REQUIRED_FIELDS) || hasRequiredFields(initialEventType, REQUIRED_FIELDS);
  const disabled = isFetching || !hasRequiredData;
  const toggleToolTipTextHide = I18n.t('publisher.scheduling.offer_time_slots_modal.toggle_tooltip.hide');
  const toggleTooltipTextShow = I18n.t('publisher.scheduling.offer_time_slots_modal.toggle_tooltip.show');
  const toolTipText = !toggleToolbar ? toggleToolTipTextHide : toggleTooltipTextShow;
  const track = useTrack();
  const handleAvailabilitySelect = data => {
    const processedData = processAvailabilityData(data, locale, bookingUrl, timeNotation, resolvedTimezone);
    if (onAvailabilitySelect) {
      onAvailabilitySelect(processedData);
    }
  };
  return <RichTextBodyFieldButtonContainer>
      <TextEditorIconWrapper onClick={handleEditorToolbarToggle} tooltip={toolTipText} toggleToolbar={!toggleToolbar}>
        <TextFormatIcon />
      </TextEditorIconWrapper>
      <OfferAvailabilityDropdown eventTypeId={eventTypeId} nextAvailability={nextAvailability} timezone={resolvedTimezone} availabilityOption={availabilityOption} onAvailabilitySelect={handleAvailabilitySelect} showSelectedState={false} ariaLabelledBy={ariaLabelledBy} disabled={disabled} loading={isFetching} buttonComponent={SuggestTimesButtonComponent} showAbove checkDisabledOptions trackAnalytics={() => trackSendViaCalendly(track, eventTypeId?.toString(), source, contact?.uuid ?? contact?.id)} contact={contact} source={source} isSendFromCalendly={isSendFromCalendly} />
    </RichTextBodyFieldButtonContainer>;
};

require("./suggest_times.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./suggest_times.js");